import { Link as LinkIcon, DangerousOutlined, LinkOff, MoreHoriz } from "@mui/icons-material";
import { Link, List, ListItem, Paper, Typography } from "@mui/material";

function ScrapReportDetailsLegacy({ scrapReport }){
    return (
        <>
        <b>{ scrapReport.scraper.name }</b> - { new Date(scrapReport.timestamp).toISOString().replace("T", " ").substring(0, 19) }
        <br />
        <br />
        <Link target="_blank" href={ scrapReport.scraper.url }>{ scrapReport.scraper.url }</Link>
        <br/>
        <br/>
        Removed: { scrapReport.removed.length } - Old: { scrapReport.old.length } - New: { scrapReport.new.length } - Buffered new: { scrapReport.bufferedNew?scrapReport.bufferedNew.length:<>Undefined</> }
        <br/>
        <br/>
    </>

    )
}

function ScrapReportDetailsNew({ scrapReport }){
    console.log(scrapReport);
    return (
        <>
        <b>{ scrapReport.scraper.name }</b> - { new Date(scrapReport.timestamp).toISOString().replace("T", " ").substring(0, 19) }
        <br />
        <br />
        <Link target="_blank" href={ scrapReport.scraper.url }>{ scrapReport.scraper.url }</Link>
        <br/>
        <br/>
       Links found: { scrapReport.linksFound?"true":"false" }
       <br/>
       Regex used: { ((scrapReport.regex == null) || (scrapReport.regex == ""))?<>None</>:scrapReport.regex }
       <br/>
       Buffered new: { scrapReport.bufferedNew?scrapReport.bufferedNew.length:<>Undefined</> }
        <br/>
        <br/>
        Total links: { scrapReport.linksAnalysed.length }
        <br/>
        <List sx={{maxHeight: 400, overflow: 'scroll'}}dense={true}>
        {
            scrapReport.linksAnalysed.map(linkItem => {
                return (
                    <>
                    <ListItem>
                        { linkItem.link }
                        { linkItem.isUseful?<></>:<DangerousOutlined/>}
                    </ListItem>
                    {
                        linkItem.isUseful?<>
                            { ((scrapReport.regex == null) || (scrapReport.regex == ""))?<></>:<>
                            <ListItem>
                                <MoreHoriz /> { linkItem.regexLink }
                            </ListItem>
                        </>
                    }
                    <ListItem>
                        {
                            linkItem.matchedTo == null?<LinkOff />:<><LinkIcon/>{linkItem.matchedTo}</>
                        }
                    </ListItem>

                        </>
                        :
                        // NOTE: not useful
                        <></>
                    }
                    <ListItem> &nbsp; </ListItem>
                    </>
                )
            })
        }
        </List>
    </>

    )
}



export default function ScrapReportDetails({ scrapReport }){
    return (
        scrapReport.old == null?<ScrapReportDetailsNew scrapReport={scrapReport}/>:<ScrapReportDetailsLegacy scrapReport={scrapReport} />
    )
}